import gql from 'graphql-tag';

export const operation = 'ProfileInfo';
export const query = gql`
query ${operation} {
  userinfo {
    id
    firstName
    lastName
    email
    authId
  }
}
`;

export function* sagas() {
  yield null;
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/account/profile/index.js